'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
var globals = require('../../../utils/globals.js');
require('./_index.scss.js');

var picturefill;

if (process.browser) {
  picturefill = require('picturefill');
}

var CLASSNAME = 'varta-img',
    cnImg = "".concat(CLASSNAME, "__img"),
    cnAnimate = "".concat(CLASSNAME, "__animate"),
    cnAnimateIn = "".concat(cnAnimate, "--in");
/**
 * 
 */

var Img = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Img, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Img);

  function Img() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Img);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      intersectionObserverSupport: _this.checkIntersectionObserverSupport(),

      /** force complete re-render in IE11*/
      sourceKey: 1
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "ref", /*#__PURE__*/React__default.createRef());

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onIntersect", function (_ref) {
      var _ref2 = _rollupPluginBabelHelpers.slicedToArray(_ref, 1),
          e = _ref2[0];

      if (e.isIntersecting) {
        _this.setState({
          inView: true
        });

        if (_this.observer) {
          _this.observer.disconnect();
        }
      }
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Img, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.addObserver();
      var intersectionObserverSupport = this.checkIntersectionObserverSupport();
      this.setState({
        intersectionObserverSupport: intersectionObserverSupport
      });

      if (!intersectionObserverSupport) {
        this.setState({
          sourceKey: 2
        });
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var srcset = this.props.srcset;
      var _this$state = this.state,
          inView = _this$state.inView,
          intersectionObserverSupport = _this$state.intersectionObserverSupport,
          sourceKey = _this$state.sourceKey;
      return JSON.stringify(srcset) !== JSON.stringify(nextProps.srcset) || inView !== nextState.inView || intersectionObserverSupport !== nextState.intersectionObserverSupport || sourceKey !== nextState.sourceKey;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (picturefill) {
        picturefill();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.observer) {
        this.observer.disconnect();
      }
    }
    /**
     * Triggered as soon as the element intersects with viewport
     *
     * @param {Array} param0 - Array of intersect objects
     */

  }, {
    key: "addObserver",
    value:
    /**
     * Add intersection observer if available and needed
     */
    function addObserver() {
      var _this$props = this.props,
          animate = _this$props.animate,
          lazy = _this$props.lazy,
          offset = _this$props.offset; // const {
      //     intersectionObserverSupport
      // } = this.state

      var intersectionObserverSupport = this.checkIntersectionObserverSupport();

      if (!intersectionObserverSupport) {
        return;
      }

      if (!((animate || lazy) && this.ref.current)) {
        return;
      }

      var options = {
        rootMargin: "".concat(offset, "px")
      };
      this.observer = new IntersectionObserver(this.onIntersect, options);
      this.observer.observe(this.ref.current);
    }
    /**
     * Create source html-elements for each breakpoint
     *
     * @returns {Array<HTMLElement>}
     */

  }, {
    key: "srcset",
    value: function srcset() {
      var _this$props2 = this.props,
          srcset = _this$props2.srcset,
          lazy = _this$props2.lazy;
      var _this$state2 = this.state,
          inView = _this$state2.inView,
          intersectionObserverSupport = _this$state2.intersectionObserverSupport;
      var keys = Object.keys(globals.breakpoints).reverse();
      return keys.map(function (key, i) {
        var src = srcset[key];

        if (!srcset[key]) {
          return null;
        }

        var attrKey = 'srcSet';
        var setLazySrc = (intersectionObserverSupport || intersectionObserverSupport === undefined) && lazy && !inView;

        if (setLazySrc) {
          attrKey = 'data-src-set';
        }

        var props = _rollupPluginBabelHelpers.defineProperty({}, attrKey, "".concat(src));

        return /*#__PURE__*/React__default.createElement("source", _rollupPluginBabelHelpers.extends({
          key: i,
          media: globals.breakpoints[key]
        }, props));
      }).filter(function (a) {
        return !!a;
      });
    }
    /**
     * Check if intersection observer is supported
     * SSR: always return true to prevent flicker after first render
     *
     * @returns {Boolean}
     */

  }, {
    key: "checkIntersectionObserverSupport",
    value: function checkIntersectionObserverSupport() {
      if (typeof window === 'undefined') {
        return undefined;
      } // return false


      return 'IntersectionObserver' in window && 'IntersectionObserverEntry' in window && 'intersectionRatio' in window.IntersectionObserverEntry.prototype;
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props3 = this.props,
          srcset = _this$props3.srcset,
          className = _this$props3.className,
          alt = _this$props3.alt,
          animate = _this$props3.animate;
      var _this$state3 = this.state,
          inView = _this$state3.inView,
          intersectionObserverSupport = _this$state3.intersectionObserverSupport,
          sourceKey = _this$state3.sourceKey;

      if (!srcset) {
        return null;
      }

      return /*#__PURE__*/React__default.createElement("picture", {
        className: CLASSNAME,
        key: sourceKey
      }, this.srcset(), /*#__PURE__*/React__default.createElement("img", {
        src: // eslint-disable-next-line max-len
        srcset.xxs || 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==',
        alt: alt,
        className: classNames(cnImg, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnAnimate, animate && (intersectionObserverSupport || intersectionObserverSupport === undefined)), _rollupPluginBabelHelpers.defineProperty(_classNames, cnAnimateIn, inView), _classNames)),
        ref: this.ref
      }));
    }
  }]);

  return Img;
}(React__default.Component);
Img.propTypes = {
  /** Alt image description */
  alt: PropTypes.string,

  /** Trigger slide-in animation on scroll */
  animate: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Lazy load images on scroll */
  lazy: PropTypes.bool,

  /**
   * Scroll offset for intersection observer
   * Please note: same observer is used for lazy loading and animations
   */
  offset: PropTypes.number,

  /** Paths to images for different sizes */
  srcset: PropTypes.shape({
    xxs: PropTypes.string,
    xs: PropTypes.string.isRequired,
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    xl: PropTypes.string,
    xxl: PropTypes.string
  }).isRequired
};
Img.defaultProps = {
  lazy: true,
  offset: 100
};

module.exports = Img;
